const content = {
  namespaced: true,
  state: {
    achievements: [],
    questions: [],
    awardedPoints: [], // Points awarded to groups by instructor
    achievementsLoaded: false,
    questionsLoaded: false,
    // Admin set data
    currentWeek: 1
  },
  mutations: {
    SET_ACHIEVEMENTS(state, achievements) {
      state.achievementsLoaded = true;
      achievements.forEach((achievement) => {
        if (typeof achievement.codes === "string") {
          achievement.codes = achievement.codes
            .split(",")
            .map((code) => code.trim());
        }

        // Convert points to integer if it's not already
        if (achievement.points !== undefined) {
          achievement.points = parseInt(achievement.points);
        }

        // Convert targetScore to integer if it's not already
        if (achievement.targetScore !== undefined) {
          achievement.targetScore = parseInt(achievement.targetScore);
        }
      });

      state.achievements = achievements;
    },
    SET_QUESTIONS(state, questions) {
      state.questionsLoaded = true;
      questions.forEach((question) => {
        question.answers = [];

        // Find all properties that start with 'answer'
        Object.keys(question).forEach((key) => {
          if (key.startsWith("answer") && key !== "answers") {
            // check if the property is not an empty string
            if (question[key] !== "") {
              question.answers.push(question[key]);
              delete question[key]; // Remove the original property
            }
            // if the property is an empty string, just delete it
            else {
              delete question[key]; // Remove the original property
            }
          }
        });
      });

      state.questions = questions;
    },
    SET_AWARDED_POINTS(state, payload) {
      state.awardedPoints = payload;
      //console.log("VUEX SET_AWARDED_POINTS", state.awardedPoints);
    }
  },
  actions: {
    setAchievements({ commit }, achievements) {
      commit("SET_ACHIEVEMENTS", achievements);
    },
    setQuestions({ commit }, questions) {
      commit("SET_QUESTIONS", questions);
    },
    setAwardedPoints({ commit }, points) {
      commit("SET_AWARDED_POINTS", points);
    }
  },
  getters: {
    getAchievements(state) {
      let achievements = state.achievements;

      return achievements;
    },
    getQuestions(state) {
      let questions = state.questions;

      return questions;
    },
    getAwardedPoints(state) {
      let points =
        state.awardedPoints.filter(
          (code) => code.tsLastUpdated > 1767130027 // dec 30, 2025
        ) || [];
      return points;
    },
    getCurrentWeek(state) {
      return state.currentWeek;
    }
  }
};

export default content;
